import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { EDIT_POINT_ACTION, setEditFacetAction } from 'store/slices/RoofEditSlice';
import { LabelOrientation, LabelWithSwitch, ModalToggle } from './style';
import { ChangeEvent } from 'react';

const PointAction = [
	// { label: 'Unmerge Points', val: EDIT_POINT_ACTION.UNMERGE_POINT },
	{ label: 'Delete Points', val: EDIT_POINT_ACTION.DELETE_POINT },
];

export default function EditFacetPointsOptionsStrip() {
	const { editPointAction } = useSelector((s: RootState) => s.roofEditData.data);
	const dispatch = useDispatch();

	function toggleEditFacetPointAction(event: ChangeEvent<HTMLInputElement>, action: EDIT_POINT_ACTION) {
		dispatch(setEditFacetAction({ actionType: event.currentTarget.checked ? action : undefined }));
	}

	return (
		<>
			{PointAction.map(action => (
				<ActionToggle
					key={action.val + '-points'}
					action={action}
					onToggle={(e) => toggleEditFacetPointAction(e, action.val)}
					selected={editPointAction}
				/>
			))}
		</>

	);
}

type ActionToggleProps = {
	action: { label: string, val: EDIT_POINT_ACTION },
	onToggle: (e: ChangeEvent<HTMLInputElement>) => void;
	selected: EDIT_POINT_ACTION | undefined;
}

function ActionToggle(props: ActionToggleProps) {
	return (
		<LabelWithSwitch>
			<LabelOrientation
				id="multiple-points"
				htmlFor={`checkbox-${props.action.val}`}
			>
				<span>{props.action.label}</span>
			</LabelOrientation>
			<ModalToggle>
				<div className='switchButton switch-delete-points bg-transparent'>
					<div className="toggle-button-cover">
						<div className="button-cover">
							<div className="button b2" id="button-13">
								<input
									id={`checkbox-${props.action.val}`}
									checked={props.action.val === props.selected}
									type="checkbox"
									className="checkbox"
									onChange={(e) => props.onToggle(e)}
								/>
								<div className="knobs">
									<span></span>
								</div>
								<div className="layer"></div>
							</div>
						</div>
					</div>
				</div>
			</ModalToggle>
		</LabelWithSwitch>
	);
}